export const GET_FILELISTBLOCK_BY_ID_M = (id, preview: boolean) => `
  query {
    fileListBlock(id: "${id}", preview: ${preview}) {
        __typename
          sys {
            id
            firstPublishedAt
            publishedAt
          }
          heading
          text {
            json
            links {
              entries {
                hyperlink {
                  ... on Page {
                    sys {
                      id
                    }
                    slug
                    content {
                      __typename
                    }
                  }
                }
              }
            }
          }
          fileListType
          dynamicFilesFilter
          categories
          yearFilter
          typeOfMediaFilter
          numberOfItems
          showTotalAmount
          sortBy
          thumbnailSize
          teaserText
          showYear
          showMonth
          showRelatedInfo
          headingType
          pagination
          linkOnFileList {
            linkText
            globalLinkItem
            reference {
              ...on Page {
                content {
                  __typename
                }
                slug
              }
              ...on FileBlock
              {
                imageVaultFile
              }
            }
            url
            variant
            ikon
            newTab
          }
          manualPostsCollection {
            items {
              name
              imageVaultFile
              metaData
              ivThumbnail
              relatedInfoLink {
                linkText
                globalLinkItem
                reference {
                  ...on Page {
                    content {
                      __typename
                    }
                    slug
                  }
                  ...on FileBlock
                  {
                    imageVaultFile
                  }
                }
                url
                newTab
                ikon
              }
              __typename
              sys{
                publishedAt
                firstPublishedAt
                id
                __typename
              }
            }
          }
        }
    }
`;
